import React from 'react';

function CheckRow({ text, color = 'var(--green)' }) {
  return (
    <div style={{ display: 'flex', gap: 10, alignItems: 'flex-start', marginBottom: 8 }}>
      <div style={{
        width: 16, height: 16, borderRadius: '50%', flexShrink: 0, marginTop: 1,
        background: color === 'var(--green)' ? 'var(--green-bg)' : 'var(--red-bg)',
        border: `1px solid ${color}`,
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        fontSize: 9, fontWeight: 700, color,
      }}>
        {color === 'var(--green)' ? '✓' : '✕'}
      </div>
      <span style={{ fontSize: 13, color: 'var(--text2)', lineHeight: 1.6 }}>{text}</span>
    </div>
  );
}

export default function CUIPolicy({ onBack }) {
  const effectiveDate  = 'June 1, 2026';
  const securityEmail  = 'theclearaudit@gmail.com';

  return (
    <div style={{
      height: '100vh', background: 'var(--bg)',
      fontFamily: 'var(--font)', color: 'var(--text)',
      overflowY: 'auto',
    }}>
      {/* Header */}
      <div style={{
        background: 'var(--bg2)', borderBottom: '1px solid var(--border)',
        padding: '0 40px', height: 60,
        display: 'flex', alignItems: 'center', justifyContent: 'space-between',
      }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
          <div style={{
            width: 30, height: 30, borderRadius: 7,
            background: 'linear-gradient(135deg, #2D7DD2, #1A4E8A)',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            fontSize: 12, fontWeight: 700, color: '#fff',
          }}>CM</div>
          <span style={{ fontSize: 15, fontWeight: 600 }}>TheClearAudit</span>
        </div>
        {onBack && (
          <span
            onClick={onBack}
            style={{ fontSize: 13, color: 'var(--accent)', cursor: 'pointer', textDecoration: 'underline' }}
          >
            Back
          </span>
        )}
      </div>

      {/* Content */}
      <div style={{ maxWidth: 800, margin: '0 auto', padding: '48px 40px 80px' }}>

        {/* Title */}
        <div style={{ marginBottom: 32 }}>
          <h1 style={{
            fontSize: 32, fontWeight: 700, color: 'var(--text)',
            marginBottom: 10, letterSpacing: '-0.01em',
          }}>
            CUI Handling Statement
          </h1>
          <div style={{ fontSize: 13, color: 'var(--text3)' }}>
            Effective date: {effectiveDate}
          </div>
        </div>

        {/* Prominent amber notice */}
        <div style={{
          background: 'rgba(245,158,11,0.1)', border: '2px solid var(--amber)',
          borderRadius: 10, padding: '20px 24px', marginBottom: 36,
          display: 'flex', gap: 16, alignItems: 'flex-start',
        }}>
          <div style={{
            width: 40, height: 40, borderRadius: 10, flexShrink: 0,
            background: 'rgba(245,158,11,0.15)',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            fontSize: 20,
          }}>
            ⚠️
          </div>
          <div>
            <div style={{ fontSize: 15, fontWeight: 700, color: 'var(--amber)', marginBottom: 6 }}>
              Important Notice for Defense Contractors
            </div>
            <div style={{ fontSize: 13, color: 'var(--amber)', lineHeight: 1.65 }}>
              <strong>TheClearAudit is a compliance PREPARATION tool. It is not an authorized CUI system.</strong>
              {' '}Do not enter classified or export-controlled information into this platform.
              Do not enter Controlled Unclassified Information (CUI) that requires handling in a
              CUI-authorized system as defined by 32 CFR Part 2002.
            </div>
          </div>
        </div>

        {/* Section 1 */}
        <div style={{ marginBottom: 32 }}>
          <h2 style={{ fontSize: 16, fontWeight: 600, color: 'var(--text)', marginBottom: 12 }}>
            1. What TheClearAudit Is
          </h2>
          <div style={{ fontSize: 13, color: 'var(--text2)', lineHeight: 1.8 }}>
            TheClearAudit is a compliance preparation and tracking platform. It helps organizations assess their readiness for CMMC Level 1, 2, and 3; NIST SP 800-171; SOC 2 Type II; ISO 27001:2022; HIPAA Security Rule; NIST CSF 2.0; PCI DSS v4.0; and FedRAMP Moderate.<br /><br />
            The platform enables you to:<br />
            • Track your assessment answers and compliance posture across all controls<br />
            • Manage remediation tasks and POA&M items<br />
            • Store evidence documents (policies, procedures, screenshots)<br />
            • Generate System Security Plans (SSPs) and compliance reports<br />
            • Grant read-only access to auditors and assessors<br />
            • Prepare for formal CMMC assessments by C3PAOs
          </div>
        </div>
        <div style={{ borderBottom: '1px solid var(--border)', marginBottom: 32 }} />

        {/* Section 2 */}
        <div style={{ marginBottom: 32 }}>
          <h2 style={{ fontSize: 16, fontWeight: 600, color: 'var(--red)', marginBottom: 12 }}>
            2. What TheClearAudit Is NOT
          </h2>
          <div style={{ fontSize: 13, color: 'var(--text2)', lineHeight: 1.8, marginBottom: 16 }}>
            TheClearAudit is <strong>NOT</strong> any of the following:
          </div>
          {[
            'An authorized CUI system as defined by 32 CFR Part 2002 and NIST SP 800-171',
            'A FedRAMP-authorized cloud service provider',
            'A classified information system (SECRET/TOP SECRET/SCI)',
            'An ITAR or EAR-controlled technical information repository',
            'A system approved for storing, processing, or transmitting operational CUI',
          ].map((item, i) => (
            <CheckRow key={i} text={item} color="var(--red)" />
          ))}
          <div style={{
            marginTop: 16, background: 'var(--red-bg)', border: '1px solid var(--red)',
            borderRadius: 8, padding: '12px 16px', fontSize: 12, color: 'var(--red)', lineHeight: 1.6,
          }}>
            If your organization's contracts, program security instructions (PSIs), or data handling policies require that CUI be processed in a CUI-authorized environment, those requirements apply regardless of what tool you use. Consult your Facility Security Officer (FSO) or Information System Security Officer (ISSO) if you are unsure.
          </div>
        </div>
        <div style={{ borderBottom: '1px solid var(--border)', marginBottom: 32 }} />

        {/* Section 3 */}
        <div style={{ marginBottom: 32 }}>
          <h2 style={{ fontSize: 16, fontWeight: 600, color: 'var(--text)', marginBottom: 16 }}>
            3. What You Should and Should Not Enter
          </h2>

          {/* Safe */}
          <div style={{
            background: 'var(--green-bg)', border: '1px solid var(--green)',
            borderRadius: 10, padding: '16px 20px', marginBottom: 20,
          }}>
            <div style={{
              fontSize: 12, fontWeight: 700, color: 'var(--green)',
              textTransform: 'uppercase', letterSpacing: '0.07em', marginBottom: 12,
            }}>
              Safe to Enter
            </div>
            {[
              'Control implementation status (Implemented / Partially Implemented / Not Implemented)',
              'General remediation notes and task descriptions (e.g., "Need to configure MFA on email accounts")',
              'Policy document names, descriptions, and template content',
              'Assessment progress and gap analysis results',
              'Personnel role titles without personal identifiers (e.g., "IT Administrator", not a person\'s name or SSN)',
              'General system names and high-level descriptions (e.g., "Corporate email system", not IP addresses or architecture)',
              'Evidence file metadata (file names, control mappings, statuses)',
              'Annual affirmation records and compliance history',
            ].map((item, i) => (
              <CheckRow key={i} text={item} color="var(--green)" />
            ))}
          </div>

          {/* Unsafe */}
          <div style={{
            background: 'var(--red-bg)', border: '1px solid var(--red)',
            borderRadius: 10, padding: '16px 20px',
          }}>
            <div style={{
              fontSize: 12, fontWeight: 700, color: 'var(--red)',
              textTransform: 'uppercase', letterSpacing: '0.07em', marginBottom: 12,
            }}>
              Do Not Enter
            </div>
            {[
              'Classified information of any kind: SECRET, TOP SECRET, SCI, SAP, or any information with a classified marking',
              'Controlled Unclassified Information (CUI) that requires handling in a CUI-authorized system under your contracts or program requirements',
              'Technical specifications of controlled defense articles or items subject to ITAR (International Traffic in Arms Regulations)',
              'Export-controlled technical data subject to EAR (Export Administration Regulations)',
              'Specific network architecture diagrams, IP addresses, firewall rules, or technical configurations that would reveal exploitable vulnerabilities',
              'Personally Identifiable Information (PII) such as Social Security Numbers, employee personnel records, or personnel security clearance details',
              'Specific contract numbers, task order numbers, or program identifiers tied to classified or sensitive programs',
              'Operational security (OPSEC) sensitive information about your organization\'s defensive capabilities or operational plans',
            ].map((item, i) => (
              <CheckRow key={i} text={item} color="var(--red)" />
            ))}
          </div>
        </div>
        <div style={{ borderBottom: '1px solid var(--border)', marginBottom: 32 }} />

        {/* Section 4 */}
        <div style={{ marginBottom: 32 }}>
          <h2 style={{ fontSize: 16, fontWeight: 600, color: 'var(--text)', marginBottom: 12 }}>
            4. Infrastructure and Data Security
          </h2>
          <div style={{ fontSize: 13, color: 'var(--text2)', lineHeight: 1.8 }}>
            TheClearAudit is hosted exclusively on US-based infrastructure:
          </div>
          <div style={{
            background: 'var(--bg2)', border: '1px solid var(--border)',
            borderRadius: 8, padding: '16px 20px', marginTop: 12,
          }}>
            {[
              { label: 'Database & Auth', val: 'Supabase (AWS US-East-1, N. Virginia)' },
              { label: 'Application Hosting', val: 'Vercel (US-based edge infrastructure)' },
              { label: 'Payment Processing', val: 'Stripe Inc. (US)' },
              { label: 'AI Processing', val: 'Third-party AI provider (US) — general compliance questions only' },
              { label: 'Data Residency', val: 'All data remains within United States borders' },
              { label: 'Encryption at Rest', val: 'AES-256' },
              { label: 'Encryption in Transit', val: 'TLS 1.3 — no unencrypted connections' },
              { label: 'Access Isolation', val: 'Row-level security (RLS) at database layer' },
            ].map(({ label, val }) => (
              <div key={label} style={{
                display: 'flex', gap: 12, justifyContent: 'space-between',
                padding: '6px 0', borderBottom: '1px solid var(--border)',
                fontSize: 13,
              }}>
                <span style={{ color: 'var(--text3)', flexShrink: 0 }}>{label}</span>
                <span style={{ color: 'var(--text)', textAlign: 'right' }}>{val}</span>
              </div>
            ))}
          </div>
          <div style={{ fontSize: 13, color: 'var(--text2)', lineHeight: 1.8, marginTop: 14 }}>
            These security measures are appropriate for a compliance preparation tool. They do not constitute the security controls required for an authorized CUI system, FedRAMP authorization, or classified information system. If your organization requires CUI-authorized infrastructure, you must use a platform that holds the appropriate authorizations.
          </div>
        </div>
        <div style={{ borderBottom: '1px solid var(--border)', marginBottom: 32 }} />

        {/* Section 5 */}
        <div style={{ marginBottom: 32 }}>
          <h2 style={{ fontSize: 16, fontWeight: 600, color: 'var(--text)', marginBottom: 12 }}>
            5. Your Responsibility
          </h2>
          <div style={{ fontSize: 13, color: 'var(--text2)', lineHeight: 1.8 }}>
            You and your organization are solely responsible for ensuring that the information you enter into TheClearAudit complies with:<br /><br />
            • Your organization's CUI handling policies and data classification procedures<br />
            • Any applicable contractual obligations with the Department of Defense or other government agencies<br />
            • Federal information handling regulations including 32 CFR Part 2002, NIST SP 800-171, DFARS 252.204-7012, and any applicable program security instructions<br />
            • Export control laws including ITAR and EAR<br />
            • Any other applicable federal, state, or local laws governing the information you handle<br /><br />
            If you are unsure whether a specific piece of information is appropriate to enter into TheClearAudit, consult your organization's Facility Security Officer (FSO), Information System Security Officer (ISSO), or legal counsel before proceeding. When in doubt, leave it out.
          </div>
        </div>
        <div style={{ borderBottom: '1px solid var(--border)', marginBottom: 32 }} />

        {/* Section 6 */}
        <div style={{ marginBottom: 32 }}>
          <h2 style={{ fontSize: 16, fontWeight: 600, color: 'var(--text)', marginBottom: 12 }}>
            6. Questions
          </h2>
          <div style={{ fontSize: 13, color: 'var(--text2)', lineHeight: 1.8 }}>
            If you have questions about TheClearAudit's data handling practices, security controls, or appropriate use of the platform, contact our security team:
          </div>
          <div style={{
            marginTop: 14, display: 'inline-flex', alignItems: 'center', gap: 10,
            background: 'var(--blue-bg)', border: '1px solid rgba(45,125,210,0.2)',
            borderRadius: 8, padding: '10px 16px', fontSize: 13,
          }}>
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="var(--accent)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
              <polyline points="22,6 12,13 2,6"/>
            </svg>
            <a href={`mailto:${securityEmail}`} style={{ color: 'var(--accent)', textDecoration: 'none', fontWeight: 500 }}>
              {securityEmail}
            </a>
          </div>
        </div>

        {/* Footer */}
        <div style={{
          marginTop: 48, padding: '20px 24px',
          background: 'var(--bg2)', border: '1px solid var(--border)',
          borderRadius: 10, textAlign: 'center',
          fontSize: 12, color: 'var(--text3)', lineHeight: 1.6,
        }}>
          TheClearAudit is built by defense contractors, for defense contractors. We understand the sensitivity of your work — that's why we're transparent about what our platform is and is not authorized to handle.
          <br />
          Questions? <span style={{ color: 'var(--accent)' }}>{securityEmail}</span>
        </div>
      </div>
    </div>
  );
}
